import React from 'react'

export default function TabCss({ customCss, setCustomCss, t }) {
  return (
    <React.Fragment>
      <p className="form-hint">{t('widget.cssInstructions') || 'CSS on eristetty shadow DOM:iin eikä vaikuta muuhun sivustoon.'}</p>
      <div className="widget-form-field">
        <textarea
          value={customCss}
          onChange={e => setCustomCss(e.target.value)}
          rows={16}
          placeholder=".title { font-size: 28px; }"
          style={{ fontFamily: 'monospace', fontSize: '13px' }}
        />
      </div>
    </React.Fragment>
  )
}
